/* FOMO live ticker: shows a random message from the JSON blob at random
   intervals, never the same one twice in a row. Timers pause while the
   tab is hidden (visibilitychange) so messages don't queue up unseen. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.fomoInit) return;
    root.dataset.fomoInit = '1';

    var textEl = root.querySelector('[data-fomo-text]');
    var blob = document.querySelector('[data-fomo-messages]');
    if (!textEl || !blob) return;

    var messages;
    try {
      messages = JSON.parse(blob.textContent)
        .map(function (m) { return m.trim(); })
        .filter(Boolean);
    } catch (e) {
      return;
    }
    if (messages.length === 0) return;

    var minGap = (parseInt(root.dataset.min, 10) || 8) * 1000;
    var maxGap = (parseInt(root.dataset.max, 10) || 18) * 1000;
    var showFor = (parseInt(root.dataset.show, 10) || 5) * 1000;
    if (maxGap < minGap) maxGap = minGap;

    var lastIndex = -1;
    var timer = null;

    function pick() {
      if (messages.length === 1) return 0;
      var i;
      do {
        i = Math.floor(Math.random() * messages.length);
      } while (i === lastIndex);
      return i;
    }

    function show() {
      lastIndex = pick();
      textEl.textContent = messages[lastIndex];
      root.classList.add('is-visible');
      timer = setTimeout(hide, showFor);
    }

    function hide() {
      root.classList.remove('is-visible');
      schedule();
    }

    function schedule() {
      var gap = minGap + Math.random() * (maxGap - minGap);
      timer = setTimeout(show, gap);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearTimeout(timer);
        root.classList.remove('is-visible');
      } else {
        schedule();
      }
    });

    /* first blink arrives quickly — that's the hook */
    timer = setTimeout(show, 4000);
  }

  function initAll() {
    document.querySelectorAll('[data-fomo]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-fomo]');
    if (root) init(root);
  });
})();
